module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/main-categories-icons/21-a06cc51c4db38061a731663e957532f7.svg";